import { B2cAdConfiguration } from '@core/authentication/authentication.models';

export const localConfig: B2cAdConfiguration = {
    loginRedirectPath: 'login-redirect',
    loginClientId: 'cbfae0fb-91ff-4d88-8f72-150a45781b0f',
    loginAuthorityProvider: 'https://kopkandeb2ctest.b2clogin.com/kopkandeb2ctest.onmicrosoft.com/',
    loginSignUpSignInFlow: 'B2C_1_SIGNUP_SIGNIN_USERFLOW_CI',
    loginSignUpFlow: 'B2C_1_SIGNUP_USERFLOW_CI',
    loginResetPasswordFlow: 'B2C_1_RESETPASSWORD_USERFLOW_CI'
};

export const errorMessages = Object.freeze({
    missingClientId: 'Missing client id, cannot get configuration'
});

export const loginPanelHashbangTrigger = '#login';

/**
 * Get the known authorities from the configuration authority provider
 * take a look on the examples:
 * 'https://kopkandeb2c.b2clogin.com/kopkandeb2c.onmicrosoft.com/' => ['https://kopkandeb2c.b2clogin.com']
 * 'https://kopkandeb2ctest.b2clogin.com/kopkandeb2ctest.onmicrosoft.com/' => ['https://kopkandeb2ctest.b2clogin.com']
 * @param config
 * @returns string[] with the known authorities
 */
export const getKnownAuthorities = (config: B2cAdConfiguration): string[] => {
    const authorityEndIndex = config.loginAuthorityProvider?.indexOf('/', 8); // 8 is the length of 'https://'
    return [config.loginAuthorityProvider?.substring(0, authorityEndIndex) ?? 'https://kopkandeb2c.b2clogin.com'];
};
